export var md5Generator = {

    init: function() {
        md5Generator.generate();
    },

    /** Generuj hash MD5 **/
    generate: function()
    {
        $("#main .md5-hash-container form").validate({
            submitHandler: function(form) {

                var formData = $('#main .md5-hash-container form').serialize();

                $.ajax({
                    type: "POST",
                    data: formData,
                    url: "md5-generator/md5-encode",
                    success: function(data) {
                        if (data != "") {
                            var jsonData = JSON.parse(data);
                            $('#main .md5-hash-container .tool-output #md5-hash-output').val(jsonData);
                        }
                    }
                });
            }
        });
    }
}
